import { render, staticRenderFns } from "./InfoBox.vue?vue&type=template&id=18fb64e4"
import script from "./InfoBox.vue?vue&type=script&lang=js"
export * from "./InfoBox.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./InfoBox.vue?vue&type=style&index=0&id=18fb64e4&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports